module.exports = __webpack_public_path__ + "static/media/pickles-package.053a856e.png";